import React from 'react';
type Variant = 'gold' | 'emerald' | 'outline';
interface ActionLinkProps {
  href: string;
  variant?: Variant;
  children: React.ReactNode;
  className?: string;
  target?: string;
  rel?: string;
  'aria-label'?: string;
}
const base = 'folder-tab inline-flex items-center justify-center gap-2.5 px-8 py-4 font-display text-[0.8rem] font-semibold uppercase tracking-[0.22em] min-h-[54px] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ink';
const variants: Record<Variant, string> = {
  gold: 'bg-gold text-ink hover:bg-gold-soft',
  emerald: 'bg-emerald text-paper hover:bg-emerald-soft',
  outline: 'bg-transparent text-gold border border-gold/70 hover:border-gold hover:bg-gold/10'
};
export function ActionLink({
  href,
  variant = 'gold',
  children,
  className = '',
  ...rest
}: ActionLinkProps) {
  return <a href={href} className={`${base} ${variants[variant]} ${className}`} {...rest} data-id="element-2" data-mp="35ts5aaq0z6w">
      {children}
    </a>;
}